import { render, staticRenderFns } from "./Tel.vue?vue&type=template&id=0fce786f&scoped=true"
import script from "./Tel.vue?vue&type=script&lang=js"
export * from "./Tel.vue?vue&type=script&lang=js"
import style0 from "./Tel.vue?vue&type=style&index=0&id=0fce786f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fce786f",
  null
  
)

export default component.exports